
import React from "react";
import { Stack, Card} from "@mui/material";
import {TextField} from "../textfield/TextField";
import { useState } from 'react';
import * as Styled from "./Form.styles";

export const Form = ({properties, children, ...rest}) => {
   
    const [values,setValues]=useState({});
    const onSubmit=(e)=>{
        e.preventDefault();
        alert(JSON.stringify(values));        
    }

    const onChange=(e)=>{   
        console.log(e.target.value);
        setValues({...values,[e.target.name]:e.target.value});
    }

    return (
    <form onSubmit={onSubmit}>
        <Card>
            <Stack direction={'column'} alignContent={'space-evenly'}>              
                {properties.fields.map(child=>{return ( <TextField name={child.name} onChange={(e)=>onChange(e)} properties={child.properties}></TextField>)})}
                <Styled.Button variant="contained" type={'submit'} onClick={(e)=>onSubmit(e)}>{properties.label}</Styled.Button>
            </Stack>
        </Card>
    </form>);
}